import * as React from "react";
import { Path } from "../styledComponents";
const PathNav = ({ repo, repoPath, setRepoPath, setRepo }) => {
  const backToRepoList = () => {
    setRepo(null);
    setRepoPath("");
  };
  const changePath = (inPath) => () => {
    if (inPath === "/") {
      setRepoPath("");
    }
    let pathArray = repoPath.split("/");
    const pathIdx = pathArray.indexOf(inPath);
    pathArray = pathArray.slice(0, pathIdx + 1);
    setRepoPath(pathArray.length === 0 ? "" : pathArray.join("/"));
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Path, { onClick: backToRepoList }, "repoList/"), repo && repoPath.split("/").map((path) => /* @__PURE__ */ React.createElement(Path, { "data-testid": path, key: path, onClick: changePath(path) }, path || "root", "/")));
};
export default PathNav;
